import { Builder } from '@builder.io/sdk';
import dynamic from 'next/dynamic';

const UnderConstruction = dynamic(() => import('./UnderConstruction').then((m) => ({ default: m.UnderConstruction })));

Builder.registerComponent(UnderConstruction, {
  name: 'UnderConstruction',
  friendlyName: 'Under Construction',
  description: 'A page indicating that the web account area is under construction.',
  inputs: [
    {
      name: 'url',
      type: 'string',
      defaultValue: '/start-quote',
      required: true,
      helperText: 'The URL to redirect to when the button is clicked.',
    },
    {
      name: 'label',
      type: 'string',
      defaultValue: 'Continue to web guest journey',
      required: true,
      helperText: 'The text to display on the button.',
    },
    {
      name: 'appLinks',
      type: 'reference',
      model: 'store-links',
    },
  ],
});
